module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-RegularItalic-WebS-f740a889f4a1fc60d984b249a6317fcc.woff2";